import { IActivity } from '@sdk/contracts';
import { Button, Flex, Modal } from 'antd';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { useMutateActivity } from '@/store/activities/useMutateActivity';

type Props = {
  activity: IActivity;
  sectionId: string;
  buttonType: 'text' | 'primary';
  fullWidth?: boolean;
  handleClose?: () => void;
};

const MODAL_WIDTH = 400;

export const RemoveActivity: React.FC<Props> = ({
  activity,
  sectionId,
  buttonType = 'text',
  fullWidth = false,
  handleClose
}) => {
  const { t } = useTranslation('CoursesTranslations');
  const { isWorking, removeActivity } = useMutateActivity();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRemoveActivity = () => {
    removeActivity(
      { activityId: activity._id, sectionId },
      {
        onSuccess: () => {
          setIsModalOpen(false);
          handleClose?.();
        }
      }
    );
  };

  return (
    <>
      <Button
        type={buttonType}
        icon={<Icon i="TrashCan" size={16} />}
        danger
        style={{ width: fullWidth ? '100%' : undefined }}
        onClick={() => setIsModalOpen(true)}>
        {t('REMOVE_ACTIVITY')}
      </Button>

      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        okText={t('REMOVE_ACTIVITY')}
        cancelText={t('CANCEL')}
        onOk={handleRemoveActivity}
        okButtonProps={{ loading: isWorking }}
        centered
        width={MODAL_WIDTH}
        title={t('REMOVE_ACTIVITY_QUESTION')}
        wrapProps={{ onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() }}>
        <Flex vertical style={{ paddingTop: 16, paddingBottom: 16 }}>
          <span>
            <Trans
              i18nKey="CoursesTranslations:REMOVE_ACTIVITY_DESCRIPTION"
              values={{ name: activity.name }}
              components={{ bold: <strong /> }}
            />
          </span>
          <span>{t('THIS_ACTION_CANNOT_BE_UNDONE')}</span>
        </Flex>
      </Modal>
    </>
  );
};
